"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryFields = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../form/fields/form-text-field");
const form_number_field_1 = require("../../form/fields/form-number-field");
const form_checkbox_1 = require("../../form/fields/form-checkbox");
const form_date_time_field_1 = require("../../form/fields/form-date-time-field");
function DictionaryFields(options) {
    const intl = react_intl_1.useIntl();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_number_field_1.FormNumberField, { name: "order", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_ORDER", defaultMessage: "Po\u0159ad\u00ED" }), helpLabel: intl.formatMessage({
                id: 'EAS_EVIDENCE_FIELD_HELP_ORDER',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "name", required: true, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_NAME", defaultMessage: "N\u00E1zev" }), helpLabel: intl.formatMessage({
                id: 'EAS_EVIDENCE_FIELD_HELP_NAME',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_checkbox_1.FormCheckbox, { name: "active", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_ACTIVE", defaultMessage: "Aktivn\u00ED" }), helpLabel: intl.formatMessage({
                id: 'EAS_EVIDENCE_FIELD_HELP_ACTIVE',
                defaultMessage: ' ',
            }), disabled: true }),
        options.FieldsComponent && react_1.default.createElement(options.FieldsComponent, null),
        react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "validFrom", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_VALID_FROM", defaultMessage: "Platn\u00FD od" }), helpLabel: intl.formatMessage({
                id: 'EAS_EVIDENCE_FIELD_HELP_VALID_FROM',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_date_time_field_1.FormDateTimeField, { name: "validTo", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_VALID_TO", defaultMessage: "Platn\u00FD do" }), helpLabel: intl.formatMessage({
                id: 'EAS_EVIDENCE_FIELD_HELP_VALID_TO',
                defaultMessage: ' ',
            }) }),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "code", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_EVIDENCE_FIELD_LABEL_CODE", defaultMessage: "K\u00F3d" }), helpLabel: intl.formatMessage({
                id: 'EAS_EVIDENCE_FIELD_HELP_CODE',
                defaultMessage: ' ',
            }) })));
}
exports.DictionaryFields = DictionaryFields;
//# sourceMappingURL=dictionary-fields.js.map